// @flow
import { type TFunction } from 'react-i18next';

type Params = {
    t: TFunction,
    action: string
};

const getAccessDeniedMessage = ({ t, action }: Params): string => {
    return t('translations:accessDenied.message', { action });
};

export default getAccessDeniedMessage;
